import React, { useEffect, useState } from "react";
import useAPI from "hooks/useAPI";
import useAccount from "hooks/useAccount";
import MirumModal from "components/MirumModal";
import { useUser } from "store/user-store";
const CodeValidate = ({ email, code, onCodeValidated, onDidDismiss, show }) => {
  const { API } = useAPI({});
  const [codeToSubmit, setCodeToSubmit] = useState(null);
  const { getAndSetUser } = useAccount();
  const { setUser, setToken } = useUser();
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    let firstInput = document.getElementById(`input_${0}`);
    if (firstInput) {
      firstInput.focus();
    }
  }, [email]);

  useEffect(() => {
    console.log("email: ", email);
  }, [email, code]);

  useEffect(() => {
    if (email && codeToSubmit?.length === 4) {
      console.log("TODO AUTO SUBMIT CODE", codeToSubmit);
      submit();
    }
  }, [codeToSubmit]);

  const submit = async () => {
    setErrorMsg(null);
    if (email && codeToSubmit) {
      let data = await API.post(
        `/user/code/validate`,
        {
          email,
          password: codeToSubmit,
        },
        null,
        () => {
          setErrorMsg("It seems that code was incorrect, please try again.");
          setCodeToSubmit(null);
        }
      );

      console.log("data", data);
      if (data) {
        // Store token and user data
        if (data.token) {
          setToken(data.token);
          console.log("🔐 Token stored");
        }
        if (data.user) {
          setUser(data.user);
          console.log("🔐 User stored");
        }
        onCodeValidated && onCodeValidated();
      }
    } else {
      console.log("no email or code", email, code);
    }
  };

  const handleChange = (e, i) => {
    constructCode();
    let nextInput = document.getElementById(`input_${i + 1}`);
    if (nextInput) {
      nextInput.focus();
    } else {
      //Check if any values are empty and then focus on that input
      for (let i = 0; i < 4; i++) {
        let input = document.getElementById(`input_${i}`);
        if (!input.value) {
          input.focus();
          break;
        }
      }
    }
  };

  const constructCode = () => {
    let code = "";
    for (let i = 0; i < 4; i++) {
      let input = document.getElementById(`input_${i}`);
      code += input.value;
    }
    setCodeToSubmit(code);
  };

  return (
    <MirumModal
      show={show}
      className="md:w-1/2"
      onDidDismiss={onDidDismiss}
      positiveBtnBody="verify"
      hideNegativeBtn={true}
      onPositiveBtnClick={submit}
      disablePositiveBtn={!codeToSubmit || codeToSubmit.length < 4}
      footerClassName="px-8"
    >
      <div className="px-8">
        <h1>please check your email</h1>
        <p className="mt-2 mb-8">
          We've sent a code to <strong className="text-black">{email}</strong>
        </p>
        {/* <p>Code: {codeToSubmit}</p> */}
        <div className="flex pb-12 items-center justify-center">
          {[0, 1, 2, 3].map((i) => {
            return (
              <div className="w-[60px] mx-1 text-center">
                <input
                  maxLength={1}
                  className="w-full mirum-otp-digit"
                  id={`input_${i}`}
                  type="tel"
                  pattern="[0-9]*"
                  onChange={(e) => {
                    handleChange(e, i);
                  }}
                  onKeyUp={(e) => {
                    if (e.key === "Backspace") {
                      let prevInput = document.getElementById(`input_${i - 1}`);
                      if (prevInput) {
                        prevInput.focus();
                      }
                    }
                  }}
                />
              </div>
            );
          })}
        </div>
        {errorMsg && (
          <div className="py-2">
            <p className="text-black">
              <strong>{errorMsg}</strong>
            </p>
          </div>
        )}
      </div>
    </MirumModal>
  );
};

export default CodeValidate;
